import { Injectable } from '@angular/core';
import { EventsSourceRunner } from 'projects/game-utils/src/lib/event-source/service/EventsSourceRunner';
import { WarcabyGameService } from './warcaby-game.service';
import { ApplicationControllerService } from 'projects/game-utils/src/lib/service/application-controller.service';
import { WeeklyEventToRankingItem } from 'projects/game-utils/src/lib/utils/WeeklyEventToRankingItem';
import { RankingStats } from 'projects/game-utils/src/lib/event-source/utils/RankingStats';
import { IdBufferOperator } from 'projects/game-utils/src/lib/event-source/set/operator/IdBufferOperator';
import { SetIfc } from 'projects/game-utils/src/lib/event-source/set/SetIfc';
import { RecShapeIfc } from 'projects/game-utils/src/lib/event-source/shape/RecShapeIfc';
import { SetListenerIfc } from 'projects/game-utils/src/lib/event-source/set/SetListenerIfc';
import { ImageService } from './image.service';

@Injectable({
  providedIn: 'root'
})
export class WarcabyEventSourceRunnerService extends EventsSourceRunner {

  constructor(private imageService:ImageService, applicationController:ApplicationControllerService, 
    private gameService:WarcabyGameService) 
  {
    super();
    this.flashvars = JSON.parse(window['flashvars']);
    //"PlayerId", "PlayerName", "PlayerImg", "LoggedId", "Wins", "Losts", "Scores"
    this.addDriver( WarcabyEventSourceRunnerService.TOTAL_SORTING_PIPE, 
      [ "string", "string", "string", "Boolean", "Number", "Number", "Number", "int", "int", "int", "Number" ], 
      [ "PlayerId", "PlayerName", "PlayerImg", "LoggedId", "Wins", "Losts", "Scores", "position", "viewportPosition", "Games", "Date" ] );
    
    this.addOperator( WarcabyEventSourceRunnerService.TOTAL_SORTING_PIPE, WarcabyEventSourceRunnerService.TOTAL_SORTING_Buffer, function( under:SetIfc ) :SetIfc {
        let buffer:IdBufferOperator = new IdBufferOperator( under );
        return buffer
    });
    
    //"PlayerId", "PlayerName", "PlayerImg", "LoggedId", "Wins", "Losts", "Scores"
    this.addDriver( WarcabyEventSourceRunnerService.WEEKLY_SORTING_PIPE, 
      [ "string", "string", "string", "Boolean", "Number", "Number", "Number", "int", "int", "int", "Number" ], 
      [ "PlayerId", "PlayerName", "PlayerImg", "LoggedId", "Wins", "Losts", "Scores", "position", "viewportPosition", "Games", "Date" ] );
    
    this.addOperator( WarcabyEventSourceRunnerService.WEEKLY_SORTING_PIPE, WarcabyEventSourceRunnerService.WEEKLY_SORTING_Buffer, function( under:SetIfc ) :SetIfc {
        let buffer:IdBufferOperator = new IdBufferOperator( under );
        return buffer
    });
    
    //"PlayerId", "PlayerName", "PlayerImg", "LoggedId", "Wins", "Losts", "Scores"
    this.addDriver( WarcabyEventSourceRunnerService.WEEKLY_FRIENDS_PIPE, 
      [ "string", "string", "string", "Boolean", "Number", "Number", "Number", "int", "int", "int", "int", "Number" ], 
      [ "PlayerId", "PlayerName", "PlayerImg", "LoggedId", "Wins", "Losts", "Scores", "position", "position_1", "viewportPosition", "Games", "Date" ] );
    
    this.addOperator( WarcabyEventSourceRunnerService.WEEKLY_FRIENDS_PIPE, WarcabyEventSourceRunnerService.WEEKLY_FRIENDS_Buffer, function( under:SetIfc ) :SetIfc {
        let buffer:IdBufferOperator = new IdBufferOperator( under );
        return buffer
    });
    
  }
  
  public addTotalListener( rankingStats:RankingStats ):void{
    this.addListener( WarcabyEventSourceRunnerService.TOTAL_SORTING_Buffer, WarcabyEventSourceRunnerService.TOTAL_SORTING_EventConverterListener, function( under:RecShapeIfc ):SetListenerIfc { 
      return new WeeklyEventToRankingItem(
        WarcabyEventSourceRunnerService.TOTAL_SORTING_EventConverterListener,
        this.gameService, under, rankingStats, this.imageService, this.applicationController );
    } );
  }
  
  public addWeeklyListener( rankingStats:RankingStats ):void{
    this.addListener( WarcabyEventSourceRunnerService.WEEKLY_SORTING_Buffer, WarcabyEventSourceRunnerService.WEEKLY_SORTING_EventConverterListener, function( under:RecShapeIfc ):SetListenerIfc { 
      return new WeeklyEventToRankingItem( WarcabyEventSourceRunnerService.WEEKLY_SORTING_EventConverterListener,
        this.gameService, under, rankingStats, this.imageService, this.applicationController );
    } );
  }
  
  public addFriendsWeeklyListener( rankingStats:RankingStats ):void{
    this.addListener( WarcabyEventSourceRunnerService.WEEKLY_FRIENDS_Buffer, WarcabyEventSourceRunnerService.WEEKLY_SORTING_EventConverterListener, function( under:RecShapeIfc ):SetListenerIfc { 
      return new WeeklyEventToRankingItem( WarcabyEventSourceRunnerService.WEEKLY_SORTING_EventConverterListener,
        this.gameService, under, rankingStats, this.imageService, this.applicationController );
    } );
  }
}
